import { IconButton, LuIcon } from "@overmap-ai/blocks"
import { type ComponentPropsWithRef, memo, type MouseEventHandler, useCallback } from "react"

import { useFallbackEditor, useHorizontalRuleState } from "../../hooks"
import { tipTapIconMapping } from "../mappings"
import type { OptionalEditorProps } from "../typings"

interface HorizontalRuleButtonProps
	extends Omit<ComponentPropsWithRef<typeof IconButton>, "children">, OptionalEditorProps {}

export const HorizontalRuleButton = memo<HorizontalRuleButtonProps>((props) => {
	const { ref, onClick, editor: editorFromProps, disabled, ...rest } = props

	const editor = useFallbackEditor(editorFromProps)
	const state = useHorizontalRuleState(editor)

	const handleClick = useCallback<MouseEventHandler<HTMLButtonElement>>(
		(e) => {
			onClick?.(e)
			if (e.defaultPrevented) return
			editor?.chain().focus().setHorizontalRule().run()
		},
		[editor, onClick],
	)

	return (
		<IconButton ref={ref} onClick={handleClick} disabled={disabled ?? !state?.canSet} {...rest}>
			<LuIcon icon={tipTapIconMapping.horizontalRule} />
		</IconButton>
	)
})
HorizontalRuleButton.displayName = "HorizontalRuleButton"
